/* eslint-disable import/no-anonymous-default-export */
import {
    SET_GENBA_AI_VIEW,
    SET_GENBA_AI_SELECTED_ACTION,
    SET_GENBA_AI_VIEW_DETAILS,
    SET_GENBA_AI_IS_OPEN,
    RESET_GENBA_AI_STATE
} from "./types";

const initialState = {
    view: "home",
    selectedAction: "PROCESS",
    isGenbaAIOpen: false,
    viewDetails: {
        visibility: false,
        details: {}
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_GENBA_AI_VIEW:
            return {
                ...state,
                view: action.payload
            };

        case SET_GENBA_AI_SELECTED_ACTION:
            return {
                ...state,
                selectedAction: action.payload
            };

        case SET_GENBA_AI_VIEW_DETAILS:
            return {
                ...state,
                viewDetails: action.payload
            };

        case SET_GENBA_AI_IS_OPEN:
            return {
                ...state,
                isGenbaAIOpen: action.payload
            };

        case RESET_GENBA_AI_STATE:
            return initialState;

        default:
            return state;
    }
};
